import { useEffect, useState } from 'react'
import { Alert, Modal, Skeleton, Stack, Text } from '@mantine/core'
import { useTranslation } from 'react-i18next'

export default function DigestPreview({ opened, onClose }) {
  const { t, i18n } = useTranslation()
  const [mail, setMail] = useState(null)
  const [error, setError] = useState(false)
  useEffect(() => {
    if (!opened) return
    const controller = new AbortController()
    setMail(null)
    setError(false)
    fetch(`/digest/preview?locale=${encodeURIComponent(i18n.language)}`, { signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(response => {
        if (!response.ok || response.redirected) throw new Error('Preview unavailable')
        return response.json()
      })
      .then(setMail)
      .catch(error => { if (error.name !== 'AbortError') setError(true) })
    return () => controller.abort()
  }, [opened, i18n.language])
  return <Modal opened={opened} onClose={onClose} title={t('Voorbeeld weekoverzicht')} size="lg">
    <Stack gap="sm">
      <Text size="sm" c="dimmed">{t('Dit zijn voorbeeldtaken. Er wordt geen mail verstuurd. Je echte weekoverzicht bevat je eigen taken.')}</Text>
      {error ? <Alert color="red">{t('Het voorbeeld kon niet worden geladen. Sluit dit venster en probeer opnieuw.')}</Alert> : mail ? <>
        <Text size="sm" fw={600}>{mail.subject}</Text>
        <iframe title={t('Voorbeeld weekoverzicht')} srcDoc={mail.html} sandbox="" style={{ width: '100%', height: 560, border: '1px solid var(--mantine-color-default-border)', borderRadius: 8, background: '#fff' }}/>
      </> : <Skeleton height={560}/>}
    </Stack>
  </Modal>
}
